import type { TodayQueueOutput } from "@/api/tools";
/** §4.1: Attention Required includes overdue in the chip, section and navigation, in every filter view. */
export const actionableCount = (queue: TodayQueueOutput | undefined): number =>
  (queue?.counts.needs_you ?? 0) + (queue?.counts.overdue ?? 0);
